var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7078 4.62656C14.6281 4.32975 14.4719 4.05907 14.2547 3.84162C14.0375 3.62417 13.767 3.46757 13.4703 3.3875C12.3781 3.09375 8 3.09375 8 3.09375C8 3.09375 3.62187 3.09375 2.52969 3.38594C2.23284 3.46575 1.96223 3.62226 1.74501 3.83975C1.52779 4.05724 1.37162 4.32806 1.29219 4.625C1 5.71875 1 8 1 8C1 8 1 10.2813 1.29219 11.3734C1.45312 11.9766 1.92812 12.4516 2.52969 12.6125C3.62187 12.9062 8 12.9062 8 12.9062C8 12.9062 12.3781 12.9062 13.4703 12.6125C14.0734 12.4516 14.5469 11.9766 14.7078 11.3734C15 10.2813 15 8 15 8C15 8 15 5.71875 14.7078 4.62656ZM6.60938 10.0938V5.90625L10.2344 7.98438L6.60938 10.0938Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8f87c88f0be479cdb54f1be0141893fa.svg";
export { ForwardRef as ReactComponent };